// @ts-nocheck
import React, { useEffect, useState } from "react";
import { PageContainer, PageHeader } from "../components/AssetBreadCrumb";
import { Skeleton, SkeletonGroup } from "../components/Skeleton";
import { modalViewsConst, setModalState } from "../store/modalSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchPCurves, fetchSolarEnergyModels } from "../store/pCurveSlice";
import { CustomModelTable } from "../components/CustomModels/CustomModelTable";
import { useNavigate } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import { listUploadData } from "../graphql/queries";
import { deleteUploadData } from "../graphql/mutations";

const PerformanceCurvePage = () => {
  const [customModelRecords, setCustomModelRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getCustomModels = async () => {
    const client = generateClient();
    try {
      const { data } = await client.graphql({
        query: listUploadData,
      });
      setCustomModelRecords(data.listUploadData.items);
    } catch (error) {
      console.log("Error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCustomModels();
  }, []);

  const deleteRecord = async (id) => {
    const client = generateClient();
    try {
      const { data } = await client.graphql({
        query: deleteUploadData,
        variables: { input: { id } },
      });

      const updatedRecords = customModelRecords.filter(
        (record) => record.id !== data.deleteUploadData.id
      );
      setCustomModelRecords(updatedRecords);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Weather"
        title="Custom AI Models"
        description="View, manage, and train your custom AI weather forecasting models."
        action={
          <button
            type="button"
            onClick={() => navigate(`/home/dataupload/new`)}
            className="eai-btn-cta"
          >
            {/* The label collapses to a bare + on a phone, where the row is tight */}
            <span className="hidden md:inline">+ New Custom Model</span>
            <span className="md:hidden">+</span>
          </button>
        }
      />

      {loading ? (
        <div className="eai-card overflow-hidden">
          <SkeletonGroup count={5} label="Loading custom models" className="divide-y divide-eai-border">
            <div className="flex items-center gap-4 px-4 py-3.5">
              <Skeleton className="h-4 w-56" />
              <Skeleton className="ml-auto h-5 w-20" radius="full" />
            </div>
          </SkeletonGroup>
        </div>
      ) : customModelRecords.length > 0 ? (
        // The pane can't stretch, so a wide table scrolls in its own box
        <div className="eai-card overflow-hidden">
          <div className="overflow-x-auto">
            <CustomModelTable
              records={customModelRecords}
              onDeleteRecord={(id) => deleteRecord(id)}
            />
          </div>
        </div>
      ) : (
        <div className="eai-card px-6 py-12 text-center">
          <p className="eai-description-sm">
            No custom models yet. Create one to get started.
          </p>
        </div>
      )}
    </PageContainer>
  );
};

export default PerformanceCurvePage;
